/**
 * Shared selection-toolbar behavior for the attendance configuration grids
 * (statuses, reasons, excused codes): tracks checkbox selections and the loaded
 * rows, and drives the Merge/Delete/Cancel actions in the fe-crud-grid
 * `selection-tools` slot.
 *
 * Consuming components must:
 *  - have an fe-crud-grid with ref="grid" that binds
 *    @selectionChanged="onSelectionChanged" and @read="onGridRead"
 *  - define a load() method that re-reads the grid
 */
export default {
    data() {
        return {
            mergeSelections: [],
            allRows: [],
            showMergeDialog: false,
            gridApi: null
        }
    },

    methods: {
        onSelectionChanged(evt) {
            if (evt && evt.api) {
                this.gridApi = evt.api
            }
            this.mergeSelections = this.gridApi ? this.gridApi.getSelectedRows() : []
        },

        onGridRead(rows) {
            this.allRows = Array.isArray(rows) ? rows : []
        },

        openMergeDialog() {
            if (this.mergeSelections.length) {
                this.showMergeDialog = true
            }
        },

        deleteSelected() {
            if (!this.mergeSelections.length) {
                return
            }
            this.$confirmDelete(this.mergeSelections, () => {
                this.$refs.grid.$refs.crud.destroy(this.mergeSelections).then(() => {
                    this.load()
                })
            })
        },

        cancelSelection() {
            if (this.gridApi) {
                this.gridApi.deselectAll()
            }
        },

        onMerged() {
            this.cancelSelection()
            this.load()
        }
    }
}
